module.exports = __webpack_public_path__ + "static/media/WWW.e641a95a.png";